/**
 * @generated SignedSource<<5b119f7451a2c8fcde7214d8be77f1da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SetTopicActiveInput = {
  isActive: boolean;
  slug: string;
};
export type TopicListSetActiveMutation$variables = {
  input: SetTopicActiveInput;
};
export type TopicListSetActiveMutation$data = {
  readonly setTopicActive: {
    readonly topic: {
      readonly canTriggerIngestion: boolean;
      readonly id: string;
      readonly isActive: boolean;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type TopicListSetActiveMutation = {
  response: TopicListSetActiveMutation$data;
  variables: TopicListSetActiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SetTopicActivePayload",
    "kind": "LinkedField",
    "name": "setTopicActive",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isActive",
            "storageKey": null
          },
          {
            "alias": "canTriggerIngestion",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "TRIGGER_INGESTION"
              }
            ],
            "kind": "ScalarField",
            "name": "canAct",
            "storageKey": "canAct(action:\"TRIGGER_INGESTION\")"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TopicListSetActiveMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopicListSetActiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6701c9cbcddc0ded14d88529c2291b53",
    "id": null,
    "metadata": {},
    "name": "TopicListSetActiveMutation",
    "operationKind": "mutation",
    "text": "mutation TopicListSetActiveMutation(\n  $input: SetTopicActiveInput!\n) {\n  setTopicActive(input: $input) {\n    topic {\n      id\n      isActive\n      canTriggerIngestion: canAct(action: TRIGGER_INGESTION)\n    }\n    userErrors {\n      field\n      message\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "20b20264d838d77de29e8629b5e1c847";

export default node;
